/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-13 15:27:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-14 12:04:37
 * @FilePath: /goldenSalesMobile/src/router/index.js
 * @Description:
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login/index.vue";
import newRoutes from "./newRoutes";

Vue.use(VueRouter);

const originRoutes = [
  // TODO 审核过后解开注释掉的404页面
  // 404

  // redirect
  {
    path: "/",
    redirect: "/homePage/homePage",
    // TODO 审核过后还原根目录的重定向路径
    // redirect: '/goods-detail/299792522',
    // query: { distributorId:'299792480' }
  },
  // 登录
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "登录",
    },
  },
  // 首页、订单列表、我的
  {
    path: "/homePage",
    component: () => import("../views/LayOut/homeTabPage.vue"),
    redirect: "/homePage/homePage",
    children: [
      {
        path: "homePage",
        name: "HomePage",
        redirect: { name: "CustomHomePage", query: { page: 1 } },
        component: () => import("../newViews/homePage/index.vue"),
        meta: {
          title: "首页",
        },
      },

      {
        path: "groupMall",
        name: "GroupMall",
        component: () => import("../newViews/groupMall/index.vue"),
        meta: {
          title: "团购",
        },
      },
      {
        path: "order",
        name: "Order",
        component: () => import("../newViews/goods/order"),
        meta: {
          title: "订单列表",
        },
      },
      {
        path: "personCenter",
        name: "PersonCenter",
        redirect: { name: "CustomHomePage", query: { page: 2 } },
        component: () => import("../newViews/personCenter/personCenter"),
        meta: {
          title: "我的",
        },
      },
    ],
  },
  {
    path: "/customHomePage",
    name: "CustomHomePage",
    // alias: '/homePage',
    component: () => import("../newViews/homePage/customHomePage.vue"),
    meta: {
      title: "首页",
    },
  },
  // {
  //   path: '/homePage/homePage',
  //   name: 'HomePage',
  //   component: () => import('../views/homePage/index.vue')
  // },
  // 商品详情
  {
    path: "/goods-detail/:id",
    name: "GoodsDetail",
    component: () => import("../views/GoodsDetail/index.vue"),
  },
  // 商品海报
  {
    path: "/goods-poster/:id/:cs",
    name: "GoodsPoster",
    component: () => import("../views/GoodsPoster/index.vue"),
  },
  // 提交订单
  {
    path: "/submit-order",
    name: "SubmitOrder",
    component: () => import("../views/SubmitOrder/index.vue"),
  },
  // 支付订单
  {
    path: "/pay-order/:id",
    name: "PayOrder",
    component: () => import("../views/SubmitOrder/payOrder.vue"),
  },
  // 分销员商品列表、销售订单、个人中心
  {
    path: "/sales",
    component: () => import("../views/LayOut/index.vue"),
    redirect: "/sales/goods-list",
    children: [
      {
        path: "address",
        name: "GoodsList",
        component: () => import("../views/GoodsList/index.vue"),
      },
      {
        path: "sales-order",
        name: "SalesOrder",
        component: () => import("../views/SalesOrder/index.vue"),
      },
      {
        path: "account-center",
        name: "AccountCenter",
        component: () => import("../views/AccountCenter/index.vue"),
      },
    ],
  },
  // 邀请注册销售员海报
  {
    path: "/invite-poster",
    name: "InvitePoster",
    component: () => import("../views/InvitePoster/index.vue"),
  },
  // 分销员注册
  {
    path: "/register-saler",
    name: "RegisterSaler",
    component: () => import("../views/RegisterSaler/index.vue"),
  },
  // 分销员团队明细
  {
    path: "/saler-group",
    name: "SalerGroup",
    component: () => import("../views/SalerGroup/index.vue"),
  },
  // 分销员佣金明细
  {
    path: "/saler-commision/:withdrawableAmount/:totalAmount/:frozenAmount",
    name: "SalerCommision",
    props: true,
    component: () => import("../views/SalerCommision/index.vue"),
  },
  // 分销员佣金提现
  {
    path: "/commision-withdraw/:withdrawableAmount",
    name: "CommisionWithdraw",
    props: true,
    component: () => import("../views/CommisionWithdraw/index.vue"),
  },
  // 消费者购物商品列表、订单列表、个人中心
  {
    path: "/users",
    component: () => import("../views/LayOut/index.vue"),
    redirect: "/users/shopping-list",
    children: [
      {
        path: "shopping-list",
        name: "ShoppingList",
        component: () => import("../views/ShoppingList/index.vue"),
      },
      {
        path: "users-order",
        name: "UsersOrder",
        component: () => import("../views/UsersOrder/index.vue"),
      },
      {
        path: "account-center",
        name: "UsersAccountCenter",
        component: () => import("../views/UsersAccountCenter/index.vue"),
      },
    ],
  },
  {
    path: "user-info",
    name: "UserInfo",
    component: () => import("../views/UsersAccountCenter/user.vue"),
  },
  {
    path: "change-phone",
    name: "ChangePhone",
    component: () => import("../views/UsersAccountCenter/changephone.vue"),
  },
  // 消费者消费码详情页
  {
    path: "/consumecode-detail/:id",
    name: "ConsumeCode",
    component: () => import("../views/UsersOrder/ConsumeCode/index.vue"),
  },
  {
    path: "/o/:id",
    name: "ConsumeCodeLink",
    component: () => import("../views/UsersOrder/ConsumeCode/index.vue"),
  },
  // 申请退款
  {
    path: "/refund-application/:id",
    name: "RefundApplication",
    component: () => import("../views/RefundOrder/Application/index.vue"),
  },
  // 退款订单列表
  {
    path: "/refund-order",
    name: "RefundOrderList",
    component: () => import("../views/RefundOrder/OrderList/index.vue"),
  },
  // 退款详情
  {
    path: "/refund-orderDetail/:id",
    name: "RefundOrderDetail",
    component: () => import("../views/RefundOrder/Detail/index.vue"),
  },
  // 支付/退款申请/提现申请结果页
  {
    path: "/result/:type/:status/:id",
    name: "Result",
    component: () => import("../views/Result/index.vue"),
  },
  // 优惠券列表
  {
    path: "/coupon",
    name: "CouponList",
    component: () => import("../views/Coupon/index"),
  },
  {
    path: "/SelfHelp/SelfCheckoutPay/:TableCode",
    name: "SelfCheckoutPay",
    component: () => import("../views/SelfHelp/SelfCheckoutPay"),
    meta: {
      title: "自助结账",
    },
  },
  {
    path: "/SelfHelp/Micropoint",
    name: "Micropoint",
    component: () => import("../views/SelfHelp/Micropoint"),
    meta: {
      title: "微点单",
    },
  },
  {
    path: "/SelfHelp/BlackMicropoint",
    name: "BlackMicropoint",
    component: () => import("../views/SelfHelp/BlackMicropoint"),
    meta: {
      title: "微点单",
    },
  },
  {
    path: "/SelfHelp/BlackInputPeopleNum",
    name: "BlackInputPeopleNum",
    component: () => import("../views/SelfHelp/BlackInputPeopleNum"),
    meta: {
      title: "选择人数",
    },
  },
  {
    path: "/SelfHelp/blackV2/BlackMicropointV2",
    name: "BlackMicropointV2",
    component: () => import("../views/SelfHelp/blackV2/BlackMicropointV2"),
    meta: {
      title: "微点单",
    },
  },
  {
    path: "/SelfHelp/blackV2/BlackInputPeopleNumV2",
    name: "BlackInputPeopleNumV2",
    component: () =>
      import("../views/SelfHelp/blackV2/BlackInputPeopleNumV2"),
    meta: {
      title: "选择人数",
    },
  },
  {
    path: "/SelfHelp/BlackCurrentConsume",
    name: "BlackCurrentConsume",
    component: () => import("../views/SelfHelp/BlackCurrentConsume"),
    meta: {
      title: "提交订单",
    },
  },
  {
    path: "/SelfHelp/blackV2/BlackCurrentConsumeV2",
    name: "BlackCurrentConsumeV2",
    component: () => import("../views/SelfHelp/blackV2/BlackCurrentConsumeV2"),
    meta: {
      title: "提交订单",
    },
  },
  {
    path: "/SelfHelp/NewMicropoint",
    name: "NewMicropoint",
    component: () => import("../views/SelfHelp/NewMicropoint"),
    meta: {
      title: "微点单",
    },
  },
  {
    path: "/SelfHelp/MicropointCurrentConsume",
    name: "MicropointCurrentConsume",
    component: () => import("../views/SelfHelp/MicropointCurrentConsume"),
    meta: {
      title: "餐品明细",
    },
  },
  {
    path: "/SelfHelp/NewPlaceOrder",
    name: "NewPlaceOrder",
    component: () => import("../views/SelfHelp/NewPlaceOrder"),
    meta: {
      title: "提交订单",
    },
  },
  {
    path: "/SelfHelp/PlaceOrderSuccess",
    name: "PlaceOrderSuccess",
    component: () => import("../views/SelfHelp/PlaceOrderSuccess"),
    meta: {
      title: "点单结果",
    },
  },
  {
    path: "/SelfHelp/BlackPlaceOrderSuccess",
    name: "BlackPlaceOrderSuccess",
    component: () => import("../views/SelfHelp/BlackPlaceOrderSuccess"),
    meta: {
      title: "点单结果",
    },
  },
  {
    path: "/SelfHelp/blackV2/BlackPlaceOrderSuccessV2",
    name: "BlackPlaceOrderSuccessV2",
    component: () =>
      import("../views/SelfHelp/blackV2/BlackPlaceOrderSuccessV2"),
    meta: {
      title: "点单结果",
    },
  },
  {
    path: "/SelfHelp/RecordsConsumption",
    name: "RecordsConsumption",
    component: () => import("../views/SelfHelp/RecordsConsumption"),
    meta: {
      title: "点单记录",
    },
  },
  {
    path: "/SelfHelp/BlackRecordConsume",
    name: "BlackRecordConsume",
    component: () => import("../views/SelfHelp/BlackRecordConsume"),
    meta: {
      title: "点单记录",
    },
  },
  {
    path: "/SelfHelp/blackV2/BlackRecordConsumeV2",
    name: "BlackRecordConsumeV2",
    component: () => import("../views/SelfHelp/blackV2/BlackRecordConsumeV2"),
    meta: {
      title: "点单记录",
    },
  },
 {
    path: "/SelfHelp/MicropointHistoryConsume",
    name: "MicropointHistoryConsume",
    component: () => import("../views/SelfHelp/MicropointHistoryConsume"),
    meta: {
      title: "点单记录",
    },
  },

  
  {
    path: "/MinMember/ValidMember",
    name: "ValidMember",
    component: () => import("../views/MinMember/ValidMember"),
    meta: {
      title: "注册微会员",
    },
  },
  {
    path: "/MinMember/RegisteredMember",
    name: "RegisteredMember",
    component: () => import("../views/MinMember/RegisteredMember"),
    meta: {
      title: "注册微会员",
    },
  },
  {
    path: "/GetCouponsCenter",
    name: "GetCouponsCenter",
    component: () => import("../views/GetCouponsCenter"),
    meta: {
      title: "领券中心",
    },
  },
  {
    path: "/MyCouponList",
    name: "MyCouponList",
    component: () => import("../views/MyCouponList"),
    meta: {
      title: "我的票券",
    },
  },
  {
    path: "/ScanGetTicket",
    name: "ScanGetTicket",
    component: () => import("../views/ScanGetTicket"),
    meta: {
      title: "领券",
    },
  },
  {
    path: "/PointMall",
    name: "PointMall",
    component: () => import("../views/PointMall"),
    meta: {
      title: "积分商城",
    },
  },
  {
    path: "/PointHistoryPage",
    name: "PointHistoryPage",
    component: () => import("../views/PointMall/history"),
    meta: {
      title: "兑换记录",
    },
  },

  {
    path: "/ReceiveGiftCoupon/:id/:sendId",
    name: "ReceiveGiftCoupon",
    component: () => import("../views/ReceiveGiftCoupon"),
    meta: {
      title: "领取票券",
    },
  },
  {
    path: "/FlashSalePage/:id",
    name: "FlashSalePage",
    component: () => import("../views/FlashSalePage"),
    meta: {
      title: "商品详情",
    },
  },
   {
    path: "/pointOrderPay/:id",
    name: "pointOrderPay",
    component: () => import("../views/pointOrderPay"),
    meta: {
      title: "支付",
    },
  },
  {
    path: "/AllFlashSaleList",
    name: "AllFlashSaleList",
    component: () => import("../views/AllFlashSaleList"),
    meta: {
      title: "抢购列表",
    },
  },
  {
    path: "/GroupBuyPage",
    name: "GroupBuyPage",
    component: () => import("../views/GroupBuyPage"),
    meta: {
      title: "拼团详情",
    },
  },
  {
    path: "/CollageSubmission",
    name: "CollageSubmission",
    component: () => import("../views/CollageSubmission"),
    meta: {
      title: "支付结果",
    },
  },

  {
    path: "/PurchaseHistory",
    name: "PurchaseHistory",
    component: () => import("../views/PurchaseHistory"),
    meta: {
      title: "交易记录",
    },
  },
  {
    path: "/SetWxAuth",
    name: "SetWxAuth",
    component: () => import("../views/SetWxAuth"),
    meta: {
      title: "微信授权",
    },
  },
  {
    path: "/goodsEvaluate",
    name: "goodsEvaluate",
    component: () => import("../views/goodsEvaluate"),
    meta: {
      title: "评价",
    },
    Permissions:{
       "scope.album": {
      "desc": "您的相机将用于评价功能"
    },
     "scope.camera": {
      "desc": "您的相机将用于评价功能"
    }
    }
  },
  {
    path: "/TotalReport",
    name: "TotalReport",
    component: () => import("../newViews/statistics/totalReport.vue"),
    meta: {
      title: "业绩汇总",
    },
  },
  {
    path: "/StatisticsHome",
    name: "StatisticsHome",
    component: () => import("../newViews/statistics/index.vue"),
    meta: {
      title: "统计",
    },
  },
  {
    path: "/TotalPerformance",
    name: "TotalPerformance",
    component: () => import("../newViews/statistics/totalPerformance.vue"),
    meta: {
      title: "业绩汇总",
    },
  },
  {
    path: "/SinglePerformance",
    name: "SinglePerformance",
    component: () => import("../newViews/statistics/singlePerformance.vue"),
    meta: {
      title: "个人业绩",
    },
  },

  {
    path: "/SalesPromotionTicheng",
    name: "SalesPromotionTicheng",
    component: () => import("../newViews/statistics/salesPromotionTicheng.vue"),
    meta: {
      title: "项目提成",
    },
  },
  {
    path: "/SaleGoodsTicheng",
    name: "SaleGoodsTicheng",
    component: () => import("../newViews/statistics/saleGoodsTicheng.vue"),
    meta: {
      title: "销售提成",
    },
  },
  {
    path: "/SaleCardTicheng",
    name: "SaleCardTicheng",
    component: () => import("../newViews/statistics/saleCardTicheng.vue"),
    meta: {
      title: "充值售卡提成",
    },
  },
  {
    path: "/JishiPerformance",
    name: "JishiPerformance",
    component: () => import("../newViews/statistics/jishiPerformance.vue"),
    meta: {
      title: "技师业绩",
    },
  },
  {
    path: "/MemberStatistics",
    name: "MemberStatistics",
    component: () => import("../newViews/statistics/memberStatistics.vue"),
    meta: {
      title: "会员统计",
    },
  },
  {
    path: "/BaseFinancialStatement",
    name: "BaseFinancialStatement",
    component: () => import("../newViews/baseFinancialStatement/index.vue"),
    meta: {
      title: "财务报表",
    },
  },
  {
    path: "/FinancialStatement",
    name: "FinancialStatement",
    component: () => import("../newViews/financialStatement/index.vue"),
    meta: {
      title: "财务报表",
    },
  },

  {
    path: "/LuckyTurntable",
    name: "LuckyTurntable",
    component: () => import("../newViews/prizeDraw/luckyTurntable.vue"),
    meta: {
      title: "幸运大转盘",
    },
  },
  {
    path: "/QueueNumber",
    name: "QueueNumber",
    component: () => import("../newViews/queueNumber/index.vue"),
    meta: {
      title: "排队取号",
    },
  },
  {
    path: "/TakeNumberSuccess",
    name: "TakeNumberSuccess",
    component: () => import("../newViews/queueNumber/takeNumberSuccess.vue"),
    meta: {
      title: "号单详情",
    },
  },
  {
    path: "/EquipManage",
    name: "EquipManage",
    component: () => import("../newViews/equipManage/index.vue"),
    meta: {
      title: "设备审批",
    },
  },

  {
    path: "/TenantOrderList",
    name: "TenantOrderList",
    component: () => import("../newViews/equipManage/tenantList.vue"),
    meta: {
      title: "商户列表",
    },
  },
  {
    path: "/VpnOrderList",
    name: "VpnOrderList",
    component: () => import("../newViews/equipManage/vpnList.vue"),
    meta: {
      title: "门店列表",
    },
  },
  {
    path: "/EquipOrderList",
    name: "EquipOrderList",
    component: () => import("../newViews/equipManage/equipList.vue"),
    meta: {
      title: "设备列表",
    },
  },
  {
    path: "/AuthOrderDetail",
    name: "AuthOrderDetail",
    component: () => import("../newViews/equipManage/orderDetail.vue"),
    meta: {
      title: "详情",
    },
  },
  {
    path: "/UnlockTenant",
    name: "UnlockTenant",
    component: () => import("../newViews/equipManage/unlockTenant.vue"),
    meta: {
      title: "解锁",
    },
  },
  {
    path: "/JiShiReportHome",
    name: "JiShiReportHome",
    component: () => import("../newViews/jishi/JiShiReportHome.vue"),
    meta: {
      title: "技师中心",
    },
  },
    {
    path: "/JiShiClockDetail",
    name: "JiShiClockDetail",
    component: () => import("../newViews/jishi/JiShiClockDetail.vue"),
    meta: {
      title: "做钟详情",
    },
  },
   {
    path: "/JiShiCommissionDetail",
    name: "JiShiCommissionDetail",
    component: () => import("../newViews/jishi/JiShiCommissionDetail.vue"),
    meta: {
      title: "提成详情",
    },
  },
  {
    path: "/JiShiCommissionAndClockDetail",
    name: "JiShiCommissionAndClockDetail",
    component: () => import("../newViews/jishi/JiShiCommissionAndClockDetail.vue"),
    meta: {
      title: "概览详情",
    },
  },
   {
    path: "/JiShiClockRoom",
    name: "JiShiClockRoom",
    component: () => import("../newViews/jishi/JiShiClockRoom.vue"),
    meta: {
      title: "技师状态图",
    },
  },
   {
    path: "/JiShiWaitClock",
    name: "JiShiWaitClock",
    component: () => import("../newViews/jishi/JiShiWaitClock.vue"),
    meta: {
      title: "待钟",
    },
  },
   {
    path: "/JiShiOnClock",
    name: "JiShiOnClock",
    component: () => import("../newViews/jishi/JiShiOnClock.vue"),
    meta: {
      title: "上钟",
    },
  },
  {
    path: "/JiShiDownClock",
    name: "JiShiDownClock",
    component: () => import("../newViews/jishi/JiShiDownClock.vue"),
    meta: {
      title: "下钟",
    },
  },
   {
    path: "/JiShiChangeClock",
    name: "JiShiChangeClock",
    component: () => import("../newViews/jishi/JiShiChangeClock.vue"),
    meta: {
      title: "换钟",
    },
  },
  {
    path: "/JishiBackClock",
    name: "JishiBackClock",
    component: () => import("../newViews/jishi/JishiBackClock.vue"),
    meta: {
      title: "退钟",
    },
  },
   {
    path: "/JiShiCancelWait",
    name: "JiShiCancelWait",
    component: () => import("../newViews/jishi/JiShiCancelWait.vue"),
    meta: {
      title: "取消待钟",
    },
  },
  {
    path: "/JiShiAddClock",
    name: "JiShiAddClock",
    component: () => import("../newViews/jishi/JiShiAddClock.vue"),
    meta: {
      title: "加钟",
    },
  },
  {
    path: "/JiShiClass",
    name: "JiShiClass",
    component: () => import("../newViews/jishi/JiShiClass.vue"),
    meta: {
      title: "班次查询",
    },
  },
    
   {
    path: "/JiShiClockDetail",
    name: "JiShiClockDetail",
    component: () => import("../newViews/jishi/JiShiClockDetail.vue"),
    meta: {
      title: "做钟明细",
    },
  },
   {
    path: "/KeyCodeQRCreate",
    name: "KeyCodeQRCreate",
    component: () => import("../newViews/KeyCodeQRCreate/KeyCodeQRCreate.vue"),
    meta: {
      title: "授权手牌",
    },
  },

   {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../newViews/boosReport/dashboard.vue"),
    meta: {
      title: "报表",
    },
  },

   {
    path: "/ReportLogin",
    name: "ReportLogin",
    component: () => import("../newViews/boosReport/ReportLogin.vue"),
    meta: {
      title: "登录",
    },
  },

   {
    path: "/ReportSetWxAuth",
    name: "ReportSetWxAuth",
    component: () => import("../newViews/boosReport/SetWxAuth/ReportSetWxAuth.vue"),
    meta: {
      title: "授权",
    },
  },
  

  {
    path: "/404",
    component: () => import("../views/404"),
    // redirect: '/'
  },
  {
    path: "*",
    redirect: "/404",
  },
];
const routes = newRoutes.concat(originRoutes);

const router = new VueRouter({
  routes,
  // base:'/hanzheng',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
